import { Card, Col, Row, Button, Spin } from "antd";
import {
  DeleteOutlined,
  PlusOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";

const AddableCardList = ({
  items,
  onAdd,
  onRemove,
  onAddConfirm,
  onCancel,
  itemName,
  renderItem,
  addButtonText,
  colSpan = 8,
}) => {
  return (
    <Row gutter={[16, 16]}>
      {items.map((item, index) => (
        <Col span={colSpan} key={item.id || index}>
          <Spin spinning={item.isLoading} style={{ height: "100%" }}>
            <Card
              title={item.title || `${itemName} ${index + 1}`}
              extra={
                item.isLocal ? (
                  <>
                    <Button
                      type="text"
                      icon={<CloseOutlined style={{ color: "red" }} />}
                      onClick={() => onCancel(item)}
                      size="small"
                      style={{ marginRight: 16 }}
                      disabled={item.isLoading}
                    />
                    <Button
                      type="text"
                      icon={<CheckOutlined style={{ color: "green" }} />}
                      onClick={() => {
                        onAddConfirm(item, index);
                      }}
                      size="small"
                      disabled={item.isLoading}
                    />
                  </>
                ) : (
                  <Button
                    type="text"
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => onRemove(item, index)}
                    size="small"
                  />
                )
              }
              style={{ height: "100%" }}
            >
              {renderItem(item, index)}
            </Card>
          </Spin>
        </Col>
      ))}
      <Col span={colSpan}>
        <Card
          style={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "200px",
          }}
          bodyStyle={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <Button
            type="dashed"
            icon={<PlusOutlined />}
            onClick={onAdd}
            size="large"
          >
            {addButtonText || `Add New ${itemName}`}
          </Button>
        </Card>
      </Col>
    </Row>
  );
};

export default AddableCardList;
